import { Link, useNavigate } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'

// Mirrors apps/mobile/app/(auth)/terms.tsx. Same copy.

export function TermsPage() {
  const navigate = useNavigate()
  return (
    <div className="min-h-full bg-navy text-white">
      <div className="px-4 pt-8 pb-4 flex items-center justify-between max-w-3xl mx-auto">
        <button onClick={() => navigate(-1)} className="text-gold p-1" aria-label="Back">
          <ChevronLeft size={24} />
        </button>
        <h1 className="text-gold text-xl font-extrabold">jnati</h1>
        <div className="w-8" />
      </div>
      <div className="max-w-3xl mx-auto px-6 pb-12">
        <h2 className="text-gold text-2xl font-extrabold text-center mt-4 mb-5">Terms &amp; Conditions</h2>

        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          These Terms &amp; Conditions govern your access to and use of the Jnati platform. By
          accessing or using our services, you agree to these terms.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">1. Introduction</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          Welcome to Jnati, a platform that helps users discover, build, and manage family
          connections. These Terms &amp; Conditions (&ldquo;Terms&rdquo;) govern your access to and use of
          the Jnati web and mobile applications, services, and any content made available
          (collectively, the &ldquo;Platform&rdquo;). By accessing or using the Platform, you agree to
          these Terms. If you do not agree, you should not use Jnati.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">2. User Eligibility</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          You must be at least 13 years old to use Jnati. If you are under the age of majority
          in your country, you must have consent from a parent or legal guardian to use the
          Platform.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">3. Account Responsibilities</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          You agree to:<br />
          • Provide accurate and truthful information during signup.<br />
          • Keep your account credentials secure and confidential.<br />
          • Accept responsibility for all activity that occurs under your account.<br />
          Jnati is not responsible for any loss or damage resulting from unauthorized access to
          your account.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">4. User Conduct</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          You must use the Platform in a respectful and lawful manner. Prohibited behaviors include:<br />
          • Impersonating others or misrepresenting relationships.<br />
          • Sharing explicit, offensive, or harmful content.<br />
          • Engaging in harassment, abuse, or spamming.<br />
          • Creating duplicate or misleading profiles.<br />
          We reserve the right to suspend or terminate accounts violating these rules.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">5. Content Ownership</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          You retain ownership of the content (photos, text, or media) you upload. However, by
          posting content on Jnati, you grant us a non-exclusive, royalty-free, worldwide
          license to use, display, and distribute that content for Platform-related purposes.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">6. Privacy and Data Usage</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          Jnati collects and stores personal information to provide core functionality. We do
          not sell your data. For full details, please review our{' '}
          <Link to="/privacy" className="text-gold underline">Privacy Policy</Link>.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">7. Relationship Features</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          Jnati allows you to build and confirm family connections. Relationships are:<br />
          • Subject to mutual confirmation.<br />
          • Categorized (e.g., parent, child, spouse) based on input.<br />
          • Managed transparently, including the ability to edit or remove them.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">8. Modifications to Terms</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          Jnati may update these Terms occasionally. When we do, we&rsquo;ll notify you via the
          Platform or email. Continued use of Jnati after changes means you accept the revised
          Terms.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">9. Termination of Access</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          We reserve the right to suspend or permanently disable access to your account if:<br />
          • You violate these Terms.<br />
          • We detect suspicious, abusive, or fraudulent activity.<br />
          • Required by law or regulation.
        </p>

        <h3 className="text-gold text-base font-bold mt-6">10. Contact</h3>
        <p className="text-[15px] leading-relaxed mt-2 text-justify">
          For any questions regarding these Terms, please contact us at:<br />
          support@jnati.com
        </p>

        <div className="text-center mt-10">
          <Link to="/login" className="text-gold underline text-[15px]">← Back to Login</Link>
        </div>
      </div>
    </div>
  )
}
